module.exports = __webpack_public_path__ + "static/media/bluesmall.1aba36b7.svg";